<template>
  <div>
    <div class="common-form">添加车费</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="名称">
        <el-input class="max-w460" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="起步价">
        <el-input class="max-w460" placeholder="请输入起步价" v-model="form.starting_price" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="低于n公里免费">
        <el-input class="max-w460" v-model="form.min_num" type="number">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="每公里价格">
        <el-input class="max-w460" v-model="form.kilometer_price" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="公里数">
        <el-input class="max-w460" v-model="form.exceed_num" type="number" placeholder="超出多少公里计算价格(默认计算起步价)">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期开始时间">
        <el-time-select v-model="form.peak_start"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '23:59'
          }" placeholder="选择时间">
        </el-time-select>
      </el-form-item>
      <el-form-item label="高峰期结束时间">
        <el-time-select v-model="form.peak_end"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '23:59'
          }" placeholder="选择时间">
        </el-time-select>
      </el-form-item>
      <el-form-item label="高峰期起步价">
        <el-input class="max-w460" v-model="form.peak_starting_price" type="number" placeholder="请输入高峰期起步价">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期每公里价格">
        <el-input class="max-w460" v-model="form.peak_kilometer_price" type="number" placeholder="请输入高峰期每公里价格">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期起步公里数">
        <el-input class="max-w460" v-model="form.peak_exceed_num" type="number" placeholder="请输入高峰期起步公里数">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="是否免费">
        <el-radio-group v-model="form.is_free">
          <el-radio :label="2">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import fareAPI from "@/api/fare.js";

export default {
  data() {
    return {
      value1:[],
      form: {
        name: "",
        min_num: "",
        starting_price: "",
        kilometer_price: "",
        exceed_num: "",
        is_free: 2,
        peak_start: null, //高峰期开始时间
        peak_end: null, //高峰期结束时间
        peak_starting_price: "", //高峰期起步价
        peak_kilometer_price: "", //高峰期每公里价格
        peak_exceed_num: null //高峰期起步公里数
      }
    };
  },
  created() { },

  methods: {
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          fareAPI
            .fareAdd(self.form, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                name: "",
                starting_price: "",
                kilometer_price: "",
                exceed_num: "",
                is_free: 1
              };
              self.$router.push("/setting/fare_setting/index");
            })
            .catch(error => { });
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/fare_setting/add.vue